export const hkdf = async (key: CryptoKey) =>
  crypto.subtle.deriveBits(
    { name: 'HKDF', hash: 'SHA-256', salt: new Uint8Array([]), info: new Uint8Array([]) },
    key,
    256
  );
